import { CONFIG } from "@component/Mortgage/Calculator/data";
import type { AbstractStepProps } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { faArrowRight as fasArrowRight } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatText } from "@ui/format";
import autobind from "autobind-decorator";
import { Button, FormCurrency, FormDecidable } from "bm-ui-kit";
import type { FormApi } from "final-form";
import React from "react";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";

const { MIN_LOAN_AMOUNT, MAX_LOAN_AMOUNT } = CONFIG;

export interface StepFields {
	loanAmount: number;
	minEmploymentRelationship: boolean;
	inKHR: boolean;
}

interface Props extends AbstractStepProps {
	realEstateValue: number;
}

export class Step4 extends AbstractStep<StepFields, Props> {
	protected initValues(): StepFields {
		return {
			loanAmount: undefined,
			minEmploymentRelationship: undefined,
			inKHR: undefined,
		};
	}

	protected renderContent(_values: StepFields, form: FormApi<StepFields>): ReactNode {
		const { realEstateValue } = this.props;

		return (
			<>
				<Card.Header className="bg-info">
					<Card.Title>
						<div className="text-white text-center">
							A megadott ingatlan értéke:
							<br />
							<mark className="d-inline-block bg-white text-info mt-2">
								{formatText(realEstateValue, "ft")}
							</mark>
						</div>
					</Card.Title>
				</Card.Header>
				<Card.Body>
					<div className="text-center mb-2">
						A törlesztő kiszámításához kérjük add meg az alábbi adatokat!
					</div>
					<FormCurrency
						label="Mekkora hitelt szeretnél felvenni?"
						name="loanAmount"
						placeholder="Add meg a hitelösszeget!"
						validate={this.validLoanAmount}
						required
					/>
					<FormDecidable
						label="Dolgozol már 3 hónapja a jelenlegi munkahelyeden?"
						name="minEmploymentRelationship"
						required
					/>
					<FormDecidable label="Szerepelsz-e a KHR-ben?" name="inKHR" required />
				</Card.Body>
				<Card.Footer className="text-center">
					<Button
						type="submit"
						icon={<FontAwesomeIcon icon={fasArrowRight} />}
						className={!form.getState().valid ? "disabled" : undefined}
					>
						Tovább
					</Button>
				</Card.Footer>
			</>
		);
	}

	@autobind
	private validLoanAmount(loanAmount: number): string {
		if (isNaN(loanAmount)) {
			return "A hitelösszeg megadása kötelező!";
		}

		if (loanAmount < MIN_LOAN_AMOUNT) {
			return `A minimálisan felvehető hitelösszeg ${formatText(MIN_LOAN_AMOUNT, "ft")}!`;
		}

		if (loanAmount > MAX_LOAN_AMOUNT) {
			return `A maximálisan felvehető hitelösszeg ${formatText(MAX_LOAN_AMOUNT, "ft")}!`;
		}

		const realEstateValue80p = this.props.realEstateValue * 0.8;

		if (loanAmount > realEstateValue80p) {
			return `A hitelösszeg nem lehet nagyobb az ingatlan értékének 80%-ánál ${formatText(
				realEstateValue80p,
				"ft",
			)}!`;
		}

		return undefined;
	}

	protected getComponentName(): string {
		return "Step4";
	}
}
